import React from 'react';
import ReactDOM from 'react-dom';
import AppHome from './AppHome';
import BoxQuoteNewHome from './components/Common/BoxQuoteNewHome'
import NewVendor from './components/NewHomepage/NewVendor'

ReactDOM.render(<AppHome />, document.getElementById('root-header'));
ReactDOM.render(<BoxQuoteNewHome />, document.getElementById('block-quote-home'));
ReactDOM.render(<NewVendor />, document.getElementById('home-list-vendor'));